import  Response, { ResponseOption }  from './views/Response.jsx';


export { Response, ResponseOption };


import  { CloseResponse }  from './views/Close.jsx';
import  { QuestionResponse }  from './views/Question.jsx';
import  { DelayResponse }  from './views/Delay.jsx';
import  { PurchaseResponse }  from './views/Purchase.jsx';


export { CloseResponse, QuestionResponse, DelayResponse, PurchaseResponse };

function getCacheKey(props)  {
    return "response-" + props.type + "-" + props.request.key;
}

export { getCacheKey };


import { doClose, doQuestion, doRecall, clearCache } from './responseSlice.js';
export { doClose, doQuestion, doRecall, clearCache };


import  ResponseTextEntry  from './views/ResponseTextEntry.jsx';
export { ResponseTextEntry };


